<template>
  <div class="detail-content" v-loading="contentLoading">
    <template v-if="BUILD_ENV == 'dev'"> {{ spuInfo }}{{ activeStepIndex }}/{{ currentStep }} </template>
    <div class="spu-panel">
      <div class="spu-img" v-if="haveSpuImg" @click="showPicture(spuInfo.picList, 0)">
        <el-image :src="spuInfo.picList[0].path" style="width: 79px; height: 79px" fit="cover"></el-image>
        <div class="img-num">{{ spuInfo.picList.length }}</div>
        <div class="layer"></div>
      </div>
      <div class="spu-panel-title flex-between">
        <div class="flex2">
          {{ spuInfo.productTypeName }}-SPU编码：{{ spuInfo.spuCode }}
          <span class="note" v-if="spuInfo.productRemark">（备注：{{ spuInfo.productRemark }}）</span>
          <span class="tips" v-if="!haveSpuImg">请先上传图片</span>
        </div>
        <div class="flex8">
          <!-- 开始制作后展示拍摄类型 -->
          <el-button
            type="primary"
            size="mini"
            v-show="activeStepIndex > 1"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$backBth'"
            @click="fallbackNodeShow"
            >回退</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-show="activeStepIndex > 0 && !isJumpRender && renderPlan"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$renderingBtn'"
            @click="renderingImportVisible = true"
            >渲染</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-show="activeStepIndex > 1 && !isJumpShot && spuInfo.productTypeCode != 5 && hasPhotographyPlan"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$retouchBtn'"
            @click="retouchImportVisible = true"
            >修片</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-show="activeStepIndex > 2 && sectionPlan"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$sectionBtn'"
            @click="sectionShow"
            >切片</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-show="activeStepIndex > 0"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Shooting category'"
            @click="hootingTypeShow"
            >拍摄类型</el-button
          >
          <el-button v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$editsku'" type="primary" size="mini" @click="editSputAllShow"
            >修改sku</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="renderBatchProcessingShow"
            v-show="!isJumpRender && !renderBatchShow && activeStepIndex > 0 && renderPlan"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Batch rendering`"
            :disabled="!haveSpuImg"
            >批量渲染</el-button
          >
          <el-button type="primary" size="mini" @click="batchProcessingShow" :disabled="!haveSpuImg">批量更新</el-button>
          <!-- #old v-show="currentStep == stepEnum.shooting && !hasPhotographyPlan"  -->
          <el-button
            v-show="!isJumpRender && activeStepIndex > 0"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$rendering'"
            type="warning"
            size="mini"
            @click="renderingShow"
            >渲染计划</el-button
          >
          <el-button
            v-show="currentStep > stepEnum.newArrival && !hasPhotographyPlan && spuInfo && spuInfo.productTypeCode != 5 && !isJumpShot"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$PhotographyPlan'"
            type="warning"
            size="mini"
            @click="photographyShow"
            >摄影计划</el-button
          >
          <!-- #old v-show="currentStep == stepEnum.design && !hasPagePlan"  -->
          <el-button
            v-show="currentStep > stepEnum.newArrival && !hasPagePlan"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$PagePlan'"
            type="warning"
            size="mini"
            @click="showPagePlan"
            >页面计划</el-button
          >
          <el-button
            v-show="hasPhotographyPlan || hasPagePlan"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$WorkPlan'"
            type="primary"
            size="mini"
            @click="workPlanShow"
            >工作计划</el-button
          >
          <el-button v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$AddSku'" type="primary" size="mini" @click="addSkuShow('')"
            >新增SKU</el-button
          >
          <!-- #old v-show="spuInfo.percent != '100%'" -->
          <el-button
            v-show="currentStep != stepEnum.finished"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ModifySPU'"
            size="mini"
            @click="editSpuShow"
            >修改</el-button
          >
          <el-button
            v-show="currentStep == stepEnum.newArrival || !skuList.length"
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$DeleteSPU'"
            size="mini"
            @click="handleDelSpu(spuInfo.dataId)"
            >删除</el-button
          >
          <el-button size="mini" @click="refresh">刷新</el-button>
        </div>
      </div>
      <div class="spu-panel-content flex-between">
        <div class="flex1 flex-between">
          <k-v-panel label="SPU名称">
            {{ spuInfo.spuName }}
          </k-v-panel>
          <k-v-panel label="预计上线时间">
            {{ spuInfo.expOnelineTime }}
          </k-v-panel>
          <k-v-panel label="完成上线占比">
            {{ spuInfo.percent }}
          </k-v-panel>
          <k-v-panel label="图片">
            <el-link v-if="haveSpuImg" type="primary" :underline="false" @click="showPicture(spuInfo.picList, 0)">查看</el-link>
            <span v-else>-</span>
          </k-v-panel>
        </div>
        <div class="flex0">
          <!-- <el-button
            type="primary"
            plain
            size="mini"
            @click="jumpProgress3(spuInfo)"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Data`"
            v-show="showProductInformationBtn && !isShowInformation">
            跳过产品资料
          </el-button> -->
          <!-- 类型为翻拍、线下同款 -->
          <!-- 拍摄完成之后，显示跳过按钮，跳过产品文案 -->
          <!-- 产品资料如果维护了，则不显示跳过按钮，走全流程 -->
          <el-button
            type="primary"
            plain
            size="mini"
            @click="jumpProgress(spuInfo)"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$jumpProgress1`"
            v-show="showPaperWorkJunmpBtn"
          >
            跳过产品文案
          </el-button>
          <!-- 类型为样品组货、不为线下同款 -->
          <!-- 开始制作完成之后，显示跳过按钮 -->
          <!-- <el-button
            type="primary"
            plain
            size="mini"
            @click="jumpProgress4(spuInfo,1,'样品组货')"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Skip the sample`"
            v-show="currentStep === this.stepEnum.sampleGroup && spuInfo.productTypeCode != 5 && !isJumpSampleGroup && !sampleAssemblyShow">
            跳过样品组货
          </el-button> -->
          <!-- 类型为拍摄、不为线下同款 -->
          <!-- 样品组货完成之后，显示跳过按钮 -->
          <!-- 制定拍摄后，则不显示跳过按钮 -->
          <el-button
            type="primary"
            plain
            size="mini"
            @click="jumpProgress4(spuInfo, 2, '拍摄')"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Skip shooting`"
            v-show="!hasPhotographyPlan && currentStep === stepEnum.shooting && spuInfo.productTypeCode != 5 && !isJumpShot"
          >
            跳过拍摄
          </el-button>
          <!-- 类型为线下同款 -->
          <!-- 产品文案上传完成之后，且页面计划有完整的计划，显示跳过按钮，跳过设计节点 -->
          <!-- <el-button
            type="primary"
            plain
            size="mini"
            @click="jumpProgress2(spuInfo.dataId)"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$jumpProgress2`"
            v-show="showDesignJunmpBtn">
            跳过设计
          </el-button> -->
          <!-- 类型为线下同款 -->
          <!-- 产品文案上传完成之后，且页面计划有完整的计划，显示跳过按钮，跳过设计节点 -->
          <el-button
            type="primary"
            plain
            size="mini"
            @click="jumpProgress4(spuInfo, 3, '渲染')"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Skip rendering`"
            v-show="currentStep < stepEnum.preparation && !renderPlan && !isJumpRender && !isCompleteRendering"
          >
            跳过渲染
          </el-button>
          <el-badge value="新" class="badge-item" :hidden="!isRemarkNew">
            <el-button type="warning" size="mini" @click="remarkShow">备注</el-button>
          </el-badge>
          <!-- 针对类型为【翻拍】【线下同款】，流程节点存在“跳过”操作的，判断spuInfo.isSkipTask是否为0,0表示用户没有跳过节点    取消产品资料-->
          <!-- <el-badge
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ProductData'"
            value="新"
            class="badge-item"
            :hidden="!isFilesNew"
            v-show="showProductInformationBtn || this.spuInfo.informationNum > 0">
            <el-button type="warning" size="mini" @click="productInfomationShow">产品资料</el-button>
          </el-badge> -->
          <!-- 产品文案的维护在产品资料后面，产品资料维护了之后，并且节点处于拍摄节点之后，才会显示产品文案 -->
          <el-badge
            v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ProductPaperwork'"
            value="新"
            class="badge-item"
            :hidden="!isIntroductionsNew"
            v-show="showPaperWorkJunmpBtn || this.spuInfo.paperworkNum > 0"
          >
            <!-- v-if="activeStepIndex > 2 && filesCount > 0"> -->
            <el-button type="warning" size="mini" @click="productPaperworkShow">产品文案</el-button>
          </el-badge>
        </div>
      </div>
    </div>
    <div class="step-panel">
      <!-- <div class="step-extra-wrap">
        <div class="step-extra" :class="{'is-success': isFileSuccess}">
          <div class="step-header">
            <div class="step-icon" :class="{'is-progress': isFileInProgress}"></div>
          </div>
          <div class="step-main" :class="{'is-progress': isFileInProgress}">
            <div class="step-title">产品资料</div>
            <div class="step-description">{{stepDescription.files}}</div>
          </div>
        </div>
      </div>
      <el-steps :active="activeStepIndex" finish-status="success">
        <el-step title="开始制作" :description="stepDescription.newArrival"></el-step>
        <el-step title="样品组货" :description="stepDescription.sampleGroup"></el-step>
        <el-step title="拍摄" :description="stepDescription.shooting"></el-step>
        <el-step title="修片" :description="stepDescription.retouching"></el-step>
        <el-step title="产品文案" :description="stepDescription.paperwork"></el-step>
        <el-step title="设计" :description="stepDescription.design"></el-step>
        <el-step title="切片" :description="stepDescription.sectioning"></el-step>
        <el-step title="准备上架" :description="stepDescription.preparation"></el-step>
        <el-step title="完成上架" :description="stepDescription.finished"></el-step>
      </el-steps> -->
      <!-- {{`${activeStepIndex}/${currentStep}`}} -->
      <div id="zrenderEl"></div>
    </div>
    <div class="sku-panel">
      <div class="sku-card" v-for="skuInfo in skuList" :key="skuInfo.code">
        <div class="sku-card-title flex-between">
          <div class="sku-card-title-left flex1">
            <span class="sku-step">{{ skuInfo.taskName }}</span>
            <!-- <k-v-panel label="SKU编码" class="sku-code">
              <span class="weighted">{{skuInfo.skuCode}}</span>
            </k-v-panel> -->
            <span style="dispaly: inline-block; line-height: 30px">
              <span style="color: #999">SKU编码：</span><span style="color: #000">{{ skuInfo.skuCode }}</span>
            </span>
            <span v-if="skuInfo.isOverTime === '1'" class="stop-tip">已超时</span>
            <span v-if="skuInfo.isEnd === '1'" class="stop-tip">已终止</span>
            <span v-if="+skuInfo.taskId == stepEnum.shooting && skuInfo.isPlan !== '1'" class="tips">请制定摄影计划</span>
            <span v-if="+skuInfo.taskId == stepEnum.design && skuInfo.isPlan !== '1'" class="tips">请制定页面计划</span>
            <!-- <span v-if="+skuInfo.taskId == stepEnum.files && !isJumpInformation" class="tips">请上传产品资料</span> -->
            <span v-if="+skuInfo.taskId == stepEnum.paperwork && !isJumpPaperWork" class="tips">请上传产品文案</span>
            <span v-if="+skuInfo.taskId < stepEnum.finished && (isFilesNew || isIntroductionsNew)" class="tips">文案有更新，请密切关注动态！</span>
            <!-- <span v-if="+skuInfo.taskId < stepEnum.finished && (isFilesNew || isIntroductionsNew)" class="tips">产品资料/文案有更新，请密切关注动态！</span> -->
            <span v-if="+skuInfo.taskId == stepEnum.finished" class="tips tip-success">上架时间：{{ skuInfo.endTime | shortDate }}</span>
          </div>
          <div class="flex0">
            <!-- 渲染 -->
            <!-- <el-button
              v-show="skuInfo.isRenderEnd != '1' && currentStep <= stepEnum.preparation && skuInfo.isRenderPlan === '1' && skuInfo.isRenderStart !== '1' && skuInfo.isCompleteRendering != 1"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Start rendering'"
              type="warning" size="mini" @click="startTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false, currentStep)">开始渲染</el-button> -->
            <el-button
              v-show="
                skuInfo.isRenderEnd != '1' &&
                currentStep <= stepEnum.preparation &&
                skuInfo.isRenderPlan === '1' &&
                skuInfo.isRenderStart == '1' &&
                skuInfo.isCompleteRendering != 1
              "
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Finish rendering'"
              type="warning"
              size="mini"
              @click="showCompleteTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false, currentStep)"
              >结束渲染</el-button
            >

            <!-- 开始制作 -->
            <el-button
              v-show="+skuInfo.taskId == stepEnum.newArrival"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartPublish'"
              type="primary"
              size="mini"
              @click="handlePulishShow(skuInfo.dataId, skuInfo.skuCode)"
              >发起上架</el-button
            >
            <el-button
              v-show="+skuInfo.taskId == stepEnum.newArrival"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$DeleteSKU'"
              size="mini"
              @click="handleDelSku(skuInfo.dataId, skuInfo.skuCode)"
              >删除</el-button
            >

            <!-- 样品组货 -->
            <!-- <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.sampleGroup && skuInfo.isPlan != '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ArrivalPlan'"
              type="primary" size="mini" @click="arrivalShow(skuInfo.dataId, skuInfo.skuCode)"
              :disabled="!haveSpuImg">到货计划</el-button>
            <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.sampleGroup && skuInfo.isPlan == '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ConfirmArrival'"
              type="primary" size="mini" @click="showConfirmArrival(skuInfo.dataId, skuInfo.skuCode)">确认到货</el-button> -->

            <!-- 摄影 -->
            <!-- <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.shooting && skuInfo.isPlan === '1' && skuInfo.isStart != '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartShooting'"
              type="primary" size="mini" @click="startTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false)">开始拍摄</el-button> -->
            <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.shooting && skuInfo.isPlan === '1' && skuInfo.isStart == '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishShooting'"
              type="primary"
              size="mini"
              @click="showCompleteTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false)"
              >完成拍摄</el-button
            >

            <!-- 修片 -->
            <!-- <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.retouching && skuInfo.isPlan === '1' && skuInfo.isStart !== '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartRetouching'"
              type="primary" size="mini" :disabled="!shootingConfig"  @click="startTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, spuId)">开始修片</el-button> -->
            <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.retouching && skuInfo.isPlan === '1' && skuInfo.isStart == '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishRetouching'"
              type="primary"
              size="mini"
              @click="showCompleteTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, spuId)"
              >完成修片</el-button
            >

            <!-- 设计 -->
            <!-- <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.design && skuInfo.isPlan === '1' && skuInfo.isStart !== '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartDesign'"
              type="primary" size="mini" @click="startTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false)">开始设计</el-button>
            <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.design && skuInfo.isPlan === '1' && skuInfo.isStart == '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishDesign'"
              type="primary" size="mini" @click="showCompleteTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false)">完成设计</el-button> -->

            <!-- 切片 -->
            <!-- <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.sectioning && skuInfo.isPlan === '1' && skuInfo.isStart !== '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartSection'"
              type="primary" size="mini" @click="startTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false)">开始切片</el-button> -->
            <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.sectioning && skuInfo.isPlan === '1' && skuInfo.isStart == '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishSection'"
              type="primary"
              size="mini"
              @click="showCompleteTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false)"
              >完成切片</el-button
            >

            <!-- 准备上架 -->
            <template v-if="skuInfo.isEnd != '1' && +skuInfo.taskId == stepEnum.preparation">
              <!-- <el-button
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$PublishNow'"
              type="primary" size="mini" @click="publishNow(skuInfo.dataId, skuInfo.skuCode, spuId, skuInfo.tableData, skuInfo.isSkipDemand, skuInfo)">立即上架</el-button> -->
              <!-- 新品、新品-线下同款、新品-增配， 显示此按钮 -->
              <el-button class="red-btn" size="mini" @click="getFailedList(skuInfo.dataId)" v-if="skuInfo.isShowBtn">准备上架失败</el-button>
              <el-button
                v-show="isSkipDemandVisible(skuInfo)"
                v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$skipDemand'"
                type="primary"
                size="mini"
                @click="skipDemand(skuInfo.dataId, skuInfo.skuCode, spuId, skuInfo.tableData)"
                :disabled="skuInfo.isSkipDemand == 1 && skuInfo.tableData.find((v) => !v.retailPrice)"
                >订单制</el-button
              >
            </template>

            <!-- 已终止 -->
            <el-button
              v-show="skuInfo.isEnd === '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$DeleteSKU'"
              size="mini"
              @click="handleDelSku(skuInfo.dataId, skuInfo.skuCode)"
              >删除</el-button
            >
            <el-button
              v-show="skuInfo.isEnd === '1'"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Restart'"
              size="mini"
              @click="restartTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, skuInfo.taskName, skuInfo.spuId)"
              >重启</el-button
            >
            <!-- 未终止 -->
            <el-button
              v-show="skuInfo.isEnd != '1' && +skuInfo.taskId != stepEnum.finished && +skuInfo.taskId != stepEnum.newArrival"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$Terminate'"
              size="mini"
              @click="terminateTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId)"
              >终止</el-button
            >
            <el-button v-show="+skuInfo.taskId != stepEnum.newArrival" size="mini" @click="showPublishProgress(skuInfo.dataId)">进度</el-button>

            <!-- 修改spu -->
            <el-button
              v-show="+skuInfo.taskId !== stepEnum.finished"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ModifySKU'"
              size="mini"
              @click="editSkuShow(skuInfo.skuCode)"
              >修改</el-button
            >
          </div>
        </div>
        <div class="sku-card-info">
          <el-row>
            <el-col :span="7">
              <k-v-panel label="SKU名称">
                {{ skuInfo.skuName }}
              </k-v-panel>
            </el-col>
            <el-col :span="4">
              <k-v-panel label="商品定位">
                {{ skuInfo.goodsLocationName }}
              </k-v-panel>
            </el-col>
            <el-col :span="4">
              <k-v-panel label="风格">
                {{ skuInfo.styleName }}
              </k-v-panel>
            </el-col>
            <el-col :span="3">
              <k-v-panel label="是否有样">
                {{ skuInfo.sampleFlag | yesOrNo }}
              </k-v-panel>
            </el-col>
            <el-col :span="3">
              <k-v-panel label="A类价">
                {{ skuInfo.promotionPriceA }}
              </k-v-panel>
            </el-col>
            <el-col :span="3">
              <k-v-panel label="日常活动到手价">
                {{ skuInfo.promotionRetailPrice }}
              </k-v-panel>
            </el-col>
          </el-row>
        </div>
        <div class="sku-related-table-desc flex-between">
          <div class="flex1">
            <span class="weighted">关联产品信息</span>
            <span v-if="!skuInfo.tableData.length" class="note">暂无关联产品，请在B2C创建对应编码，然后点击右侧刷新数据。</span>
            <span v-else class="note">右侧可刷新、关联产品/首批需求/财务订单</span>
          </div>
          <!-- <div class="flex0">
            <el-button size="mini" @click="refreshSku(skuInfo.dataId, skuInfo.skuCode)">刷新</el-button>
          </div> -->
        </div>
        <el-table v-loading="skuInfo.loading" border stripe ref="tableRef" class="sku-related-table" :data="skuInfo.tableData">
          <el-table-column label="图片" width="60" class-name="action-column">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.productMedias && scope.row.productMedias.length"
                class="txt-btn"
                type="text"
                size="small"
                @click="showPicture(scope.row.productMedias, 0)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="productCode" label="产品编码" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="newPro" label="新/旧" width="60" show-overflow-tooltip></el-table-column>
          <el-table-column prop="variety" label="品类" show-overflow-tooltip></el-table-column>
          <el-table-column prop="category" label="品类细分" show-overflow-tooltip></el-table-column>
          <el-table-column prop="style" label="风格" show-overflow-tooltip></el-table-column>
          <el-table-column prop="space" label="空间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="plate" label="所属板块" show-overflow-tooltip></el-table-column>
          <el-table-column prop="color" label="主色" show-overflow-tooltip></el-table-column>
          <el-table-column prop="measure" label="尺寸" show-overflow-tooltip></el-table-column>
          <el-table-column prop="length" label="长" width="60" show-overflow-tooltip></el-table-column>
          <el-table-column prop="width" label="宽" width="60" show-overflow-tooltip></el-table-column>
          <el-table-column prop="price" label="价格" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sampleFlag" label="是否有样" show-overflow-tooltip></el-table-column>
          <el-table-column prop="demand" label="首批需求" show-overflow-tooltip fixed="right" align="center" width="95">
            <template #header>
              <el-popover placement="top" width="300" trigger="click">
                <div class="pop-box">
                  <div class="pop-box-title">如何完成“首批需求”？</div>
                  <div class="pop-box-content">前提条件：通过SKU编码搜索到对应的产品关联信息。</div>
                  <div class="pop-box-content">
                    产品编号，对应的“计划”大于等于0，则认为首批需求已提报。
                    <span>（数据来源于IOC）</span>
                  </div>
                </div>
                <div slot="reference" class="pop-reference">首批需求<i class="el-icon-question"></i></div>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-button v-if="scope.row.demand" size="mini" type="primary" icon="el-icon-check" circle class="check-btn"></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="retailPrice" label="财务定价" show-overflow-tooltip fixed="right" align="center" width="95">
            <template #header>
              <el-popover placement="top" width="300" trigger="click">
                <div class="pop-box">
                  <div class="pop-box-title">如何完成“财务定价”？</div>
                  <div class="pop-box-content">前提条件：通过SKU编码搜索到对应的产品关联信息。</div>
                  <div class="pop-box-content">在“电商运营/商品管理/产品搜索及维护/产品基础价格维护”模块，对应的产品编号进行价格维护。</div>
                </div>
                <div slot="reference" class="pop-reference">财务定价<i class="el-icon-question"></i></div>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-button v-if="scope.row.retailPrice" size="mini" type="primary" icon="el-icon-check" circle class="check-btn"></el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" class-name="action-column" fixed="right">
            <template slot-scope="scope">
              <el-button class="txt-btn" type="text" size="small" @click="showProductDetail(scope.row.productCode, scope.row.productName)">查看</el-button>
              <el-button class="txt-btn" type="text" size="small" @click="editProductShow(scope.row, skuInfo)" v-if="scope.row.isEdit == 1">编辑</el-button>
              <el-button class="txt-btn" type="text" size="small" style="color: #f56c6c" @click="deleteProduct(scope.row, skuInfo)" v-if="scope.row.isEdit == 1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <add-sku
      v-model="skuVisible2"
      v-if="skuVisible2"
      :skuList="skuList"
      :spuId="spuId"
      :spuType="spuInfo.productTypeCode"
      :spuInfo="spuInfo"
      @success="updateSkuList"
    ></add-sku>
    <edit-sku v-model="skuVisible" v-if="skuVisible" :skuCode="skuCode" :spuId="spuId" :spuType="spuInfo.productTypeCode" @success="updateSkuList"></edit-sku>
    <edit-sku-all
      v-model="skuVisibleAll"
      v-if="skuVisibleAll"
      :skuCode="skuCode"
      :spuId="spuId"
      :skuData="spuInfo.skuList"
      :spuType="spuInfo.productTypeCode"
      @success="updateSkuList"
    ></edit-sku-all>
    <edit-spu v-model="spuVisible" v-if="spuVisible" :spuCode="spuCode" @success="getSpuDetail"></edit-spu>
    <edit-product v-model="editProductVisible" v-if="editProductVisible" :productData="editProductData" @success="updateSkuList"></edit-product>
    <arrival
      v-model="arrivalVisible"
      v-if="arrivalVisible"
      :skuId="skuId"
      :skuCode="skuCode"
      :spuId="spuId"
      @success="updateAfterOperation"
      @batchSuccess="updateAfterBatchOperation"
    ></arrival>
    <confirm-arrival
      v-model="confirmArrivalVisible"
      v-if="confirmArrivalVisible"
      :skuId="skuId"
      :skuCode="skuCode"
      :spuId="spuId"
      @success="updateAfterOperation"
      @batchSuccess="updateAfterBatchOperation"
    ></confirm-arrival>
    <group-goods v-model="groupGoodsVisible" v-if="groupGoodsVisible"></group-goods>
    <photography v-model="photographyVisible" v-if="photographyVisible" :spuCode="spuCode" @success="onAddPlan"></photography>
    <rendering-schedule v-model="renderingVisible" v-if="renderingVisible" :spuCode="spuCode" :spuId="spuId" @success="onAddPlan"></rendering-schedule>
    <page-plan v-model="pagePlanVisible" v-if="pagePlanVisible" :spuCode="spuCode" :isJumpDesign="isJumpDesign" @success="onAddPlan"></page-plan>
    <failed-list v-model="failedListVisible" v-if="failedListVisible" :skuId="failedSkuId" :spuId="spuId"></failed-list>
    <retouch-import
      :visible.sync="retouchImportVisible"
      v-if="retouchImportVisible"
      :spuId="spuId"
      :taskId="currentStep"
      :retouchImportShow="retouchImportShow"
      @success="init"
    >
    </retouch-import>
    <rendering-import :visible.sync="renderingImportVisible" v-if="renderingImportVisible" :spuId="spuId" :renderImportShow="renderImportShow" @success="init">
    </rendering-import>
    <section-import
      :visible.sync="sectionVisible"
      v-if="sectionVisible"
      :spuId="spuId"
      :spuName="spuInfo.spuName"
      :spuCode="spuCode"
      :sectionImportShow="sectionImportShow"
      @success="init"
    >
    </section-import>
    <fallback-node :visible.sync="fallbackNodeVisible" v-if="fallbackNodeVisible" :spuId="spuId" :skuList="skuList" @success="init"></fallback-node>
    <workPlan
      v-if="workPlanVisible"
      :visible.sync="workPlanVisible"
      :currentStep="currentStep"
      :activeStepIndex="activeStepIndex"
      :spuId="spuId"
      :hasPhotographyPlan="hasPhotographyPlan"
      :hasPagePlan="hasPagePlan"
      :isJumpDesign="isJumpDesign"
      :renderPlan="renderPlan"
      :isJumpRender="isJumpRender"
      @success="getSpuDetail"
    ></workPlan>
    <!-- 产品资料 -->
    <productInfomation
      :visible.sync="productInfomationVisible"
      :spuId="spuId"
      :spuInfo="spuInfo"
      v-if="productInfomationVisible"
      @success="updateProgressInfo"
      @close="checkFilesNew"
    ></productInfomation>
    <!-- 产品文案 -->
    <productPaperwork
      :visible.sync="productPaperworkVisible"
      :spuId="spuId"
      v-if="productPaperworkVisible"
      @success="updateProgressInfo"
      @close="checkFilesNew"
    ></productPaperwork>
    <design v-model="designVisible" v-if="designVisible"></design>
    <publish-progress :visible.sync="isShowProgress" v-if="isShowProgress" :skuId="skuId" :spuInfo="spuInfo"></publish-progress>
    <img-preview v-model="isShowPicture" :data="picData" :detailType="0" v-if="isShowPicture"></img-preview>
    <complete-task
      v-model="completeTaskVisible"
      v-if="completeTaskVisible"
      :skuId="skuId"
      :skuCode="skuCode"
      :taskId="taskId"
      :spuId="retouchingSpuId"
      :renderShow="renderShow"
      @success="updateAfterOperation"
      @batchSuccess="updateAfterBatchOperation"
    ></complete-task>
    <related-product-detail :visible.sync="relatedDetailVisible" v-if="relatedDetailVisible" :productCode="productCode" :productName="productName" />
    <!-- 批量更新 -->
    <batchProcessing
      :visible.sync="batchProcessingVisible"
      :spuId="spuId"
      :skuList="skuList"
      v-if="batchProcessingVisible"
      @complete="handleBatchProcessingComplete"
    ></batchProcessing>
    <!-- 批量渲染 -->
    <renderBatchProcessing
      :visible.sync="renderBatchProcessingVisible"
      :spuId="spuId"
      :skuList="skuList"
      v-if="renderBatchProcessingVisible"
      @complete="batchRender"
    ></renderBatchProcessing>
    <!-- 备注 -->
    <remark v-model="remarkVisible" :spuId="spuId" :skuList="skuList" v-if="remarkVisible" @close="checkFilesNew"></remark>
    <!-- 拍摄类型 -->
    <hooting-type v-model="hootingTypeVisible" :spuId="spuId" :skuList="skuList" @success="checkFilesNew" v-if="hootingTypeVisible"></hooting-type>
  </div>
</template>

<script>
const FINISHED_TASK_ID = 110;

import mixin from './mixin';
import KVPanel from '../components/k-v-panel.vue';
import PublishProgress from './publish-progress.vue';
import imgPreview from '@/views/components/imgPreview.vue';
import NP from 'number-precision';
import { assignValue } from '@/utils';
import { newProductStepEnum as stepEnum } from '@/utils/constant';
import stepMin from './step.mixin';

export default {
  name: 'NewProductDetail',
  mixins: [mixin, stepMin],
  components: {
    KVPanel,
    PublishProgress,
    imgPreview,
  },
  data() {
    return {
      that: this,
      stepList: [],
      stepMap: {},
      stepEnum: stepEnum,
      spuCode: '',
      spuInfo: {},
      stepDescription: {},
      skuList: [],
      // 全局loading
      contentLoading: false,
      // 产品资料数量
      filesCount: 0,
      // 产品文案数量
      introductionsCount: 0,
      isFilesNew: false,
      isIntroductionsNew: false,
      isRemarkNew: false,
      // 查看进度
      isShowProgress: false,
      // 查看图片
      isShowPicture: false,
      picData: {},
      failedSkuId: '',
      // 操作的skuId
      skuId: '',
      skuCode: '',
      spuId: '',
      taskId: '',
      retouchingSpuId: '',
      productCode: '',
      productName: '',
      // 当前流程节点
      currentStep: '',
      // 是否制定摄影计划
      hasPhotographyPlan: false,
      // 是否制定页面计划
      hasPagePlan: false,
      // 是否制定渲染计划
      renderPlan: false,
      //是否制定了切片计划
      sectionPlan: false,
      stepMin: false,
      //拍摄类型是否维护
      shootingConfig: false,
      renderNum: '',
    };
  },
  computed: {
    // 当前流程节点index
    activeStepIndex() {
      const stepIndexMap = {
        // 新品上架
        [stepEnum.newArrival]: 0,
        // 样品组货
        // [stepEnum.sampleGroup]: 1,
        // 拍摄
        [stepEnum.shooting]: 1,
        // 修片
        [stepEnum.retouching]: 2,

        // [stepEnum.paperwork]: 4,

        // 设计
        // [stepEnum.design]: 3,
        // 切片
        [stepEnum.sectioning]: 3,
        // 准备上架
        [stepEnum.preparation]: 4,
        // 完成上架
        [stepEnum.finished]: 5,
      };

      // TODO 多个sku，实际流程都在开始制作
      // 产品资料节点
      if (this.currentStep === stepEnum.files) {
        return 3;
      }
      // 产品文案节点
      if (this.currentStep === stepEnum.paperwork) {
        return 3;
      }

      return stepIndexMap[this.currentStep] || 0;
    },
    // // 当前节点是产品资料
    // isFileInProgress() {
    //   return this.currentStep === stepEnum.files;
    // },
    // // 产品资料已完成
    // isFileSuccess() {
    //   // 修片后并且至少有一份资料
    //   return this.currentStep > stepEnum.files || this.filesCount > 0;
    // }
    // spu是否上传了图片
    haveSpuImg() {
      if (this.spuInfo.hasOwnProperty('picList')) {
        return this.spuInfo.picList && this.spuInfo.picList.length;
      } else {
        return false;
      }
    },
    //跳过节点总数
    skipSum() {
      return this.spuInfo.allSkipTask ? this.spuInfo.allSkipTask : [];
    },
    // 是否跳过了产品文资料节点
    isJumpInformation() {
      if (this.spuInfo && this.spuInfo.isSkipTask > 0) {
        return this.skipSum && this.skipSum.includes('3');
      } else {
        return false;
      }
    },
    //渲染所有sku是否全部上传
    renderImportShow() {
      let num = this.renderNum ? this.renderNum.charAt(0) : 0;
      return num == this.skuList.length;
    },

    //修片所有sku是否全部上传
    retouchImportShow() {
      let taskIdList = this.skuList ? this.skuList.map((v) => v.taskId) : [];
      return taskIdList.every((num) => num > this.stepEnum.retouching);
    },

    //切片是否有sku在当前节点
    sectionImportShow() {
      let taskIdList = this.skuList ? this.skuList.map((v) => v.taskId) : [];
      return taskIdList.some((num) => num == this.stepEnum.sectioning);
    },

    //所有sku完成渲染后
    renderBatchShow() {
      return this.skuList.filter((v) => v.isCompleteRendering == 1).length == this.skuList.length;
    },
    //所有sku开始渲染后
    renderAllShow() {
      return this.skuList.filter((v) => v.isRenderStart == 1).length == this.skuList.length;
    },
    //是否有sku制定了到货计划
    sampleAssemblyShow() {
      return this.skuList.filter((v) => v.isEnd != '1' && +v.taskId == this.stepEnum.sampleGroup && v.isPlan == '1').length >= 1;
    },
    // 是否完成渲染
    isCompleteRendering() {
      if (!this.currentStep || !this.skuList.filter((v) => v.taskId == this.currentStep).length) {
        return true;
      } else {
        return (
          this.currentStep &&
          this.skuList.filter((v) => v.taskId == this.currentStep).length &&
          this.skuList.filter((v) => v.taskId == this.currentStep)[0].isCompleteRendering == 1
        );
      }
    },
    // 是否完成开始渲染
    isCompleteRenderStart() {
      return this.skuList.filter((v) => v.taskId == this.currentStep)[0].isRenderStart == 1;
    },
    // // 是否跳过样品组货
    // isJumpSampleGroup() {
    //   return this.skipSum && this.skipSum.includes('4')
    // },
    // 是否跳过拍摄
    isJumpShot() {
      return this.skipSum && this.skipSum.includes('5');
    },
    // 是否跳过修片
    isJumpTrimming() {
      return this.skipSum && this.skipSum.includes('6');
    },
    // 是否跳过渲染
    isJumpRender() {
      return this.skipSum && this.skipSum.includes('7');
    },
    // 是否跳过了产品文案节点
    isJumpPaperWork() {
      if (this.spuInfo && this.spuInfo.isSkipTask > 0) {
        return this.skipSum && this.skipSum.includes('1');
      } else {
        return false;
      }
    },
    // 是否跳过了设计节点
    isJumpDesign() {
      if (this.spuInfo && this.spuInfo.isSkipTask >= 2) {
        return this.skipSum && this.skipSum.includes('2');
      } else {
        return false;
      }
    },
    //有多个相同节点的sku时，点击一个sku重启，产品资料跳过和文案是否显示校验
    //如果最慢节点是小于设计前并且重启前没有上传文案和资料则无论当前节点在哪都显示
    restarPaperWork() {
      if (this.spuInfo) {
        return this.stepMin < 107 && this.currentStep >= 107;
      } else {
        return false;
      }
    },
    restarDesign() {
      //重启时设计跳过是否显示
      if (this.spuInfo) {
        return this.stepMin == 107 && this.currentStep >= 107;
      } else {
        return false;
      }
    },

    // 是否展示产品文案跳过按钮
    showPaperWorkJunmpBtn() {
      // if(this.spuInfo && (this.spuInfo.productTypeCode == 2 || this.spuInfo.productTypeCode == 5)) {
      if (this.spuInfo) {
        return this.activeStepIndex > 1 && this.spuInfo.paperworkNum == 0 && this.spuInfo.isSkipTask != 1 && !this.isJumpPaperWork;
      } else {
        return false;
      }
    },
    // // 是否展示设计跳过按钮
    // showDesignJunmpBtn() {
    //   if(this.spuInfo && this.spuInfo.productTypeCode == 5) {
    //     return (this.activeStepIndex == 4 || this.restarDesign) && !this.hasPagePlan && this.spuInfo.isSkipTask != 2
    //   }else{
    //     return false
    //   }
    // },
    // 是否展示产品资料跳过按钮
    showProductInformationBtn() {
      if (this.spuInfo) {
        return (
          (this.activeStepIndex < 3 || this.restarPaperWork) && this.spuInfo.informationNum == 0 && this.spuInfo.isSkipTask != 3 && !this.isJumpInformation
        );
      } else {
        return false;
      }
    },
    //SPU类别除翻拍，其余类型传了产品文案，产品资料跳过按钮隐藏
    isShowInformation() {
      return this.spuInfo.productTypeCode != '2' && this.spuInfo.paperworkNum > 0;
    },
  },
  methods: {
    async init() {
      this.spuCode = this.$route.query.spuCode;
      this.spuId = +this.$route.query.spuId;
      if (!this.spuCode || !this.spuId) return;

      try {
        this.contentLoading = true;
        // 接口返回taskName
        // await this.getStepList();
        this.checkFilesNew();
        // 搜索SPU信息
        await this.getProgressInfo();
        await this.getSpuDetail();
        this.checkHasPlan();
        // 搜索产品资料和产品文案数量
        // this.getFilesCount();

        this.contentLoading = false;
      } catch (error) {
        this.contentLoading = false;
      }
    },
    getStepList() {
      return this.$q.newProduct
        .getTask()
        .then(({ data }) => {
          if (Array.isArray(data)) {
            data.forEach((item) => {
              this.stepMap[item.taskId] = item.taskName;
            });
          }
        })
        .catch(console.log);
    },
    // 搜索流程节点信息
    getProgressInfo() {
      const params = {
        params: {
          spuId: this.spuId,
        },
      };
      return this.$q.newProduct
        .getProgressInfo(params)
        .then(({ data }) => {
          if (Array.isArray(data)) {
            const filesNode = data.find((item) => +item.taskId === 150);
            if (filesNode) {
              this.filesCount = filesNode.num || 0;
            }

            const taskIds = data.map((item) => +item.taskId).filter((taskId) => taskId !== 150 && taskId !== 160 && taskId !== 111);
            this.currentStep = Math.max(...taskIds);
            this.stepMin = Math.min(...taskIds);
            this.updateStepDescription(data);
            console.log('currentStep', this.currentStep, taskIds);
          }
        })
        .catch(console.log);
    },
    // 搜索spu详情
    getSpuDetail(type, curTaskId) {
      var params = {
        data: {
          pageNum: 1,
          pageSize: 1,
          filterData: {
            spuCode: this.spuCode,
          },
        },
      };
      if (curTaskId) {
        params.data.filterData.curTaskId = curTaskId;
      }
      return this.$q.newProduct
        .listPage(params)
        .then(({ data }) => {
          // 删除所有sku后，跳转到列表
          if (!data || !data.records || !data.records.length) {
            this.$router.push('/newProduct/newproduct-process');
            return;
          }
          const spuInfo = (data && data.records && data.records[0]) || {};
          // 公式=完成上架SKU数量/总SKU数量，取小数点后一位、四舍五入
          const skuList = spuInfo.skuList || [];
          const finishedSkuList = skuList.filter((item) => +item.taskId === FINISHED_TASK_ID);
          let percent = '0%';
          if (skuList.length) {
            percent = NP.times(parseFloat((finishedSkuList.length / skuList.length).toFixed(3)), 100) + '%';
          }
          this.spuInfo = {
            ...spuInfo,
            percent,
          };
          console.log('spuinfo', this.spuInfo);
          this.skuList = skuList.map((item) => {
            return {
              ...item,
              loading: true,
              tableData: [],
            };
          });
          let renderNum = this.skuList.filter((v) => v.isCompleteRendering == 1).length;
          this.renderNum = renderNum > 0 ? `${renderNum}个SKU已完成` : '';
          console.log('skuList', this.skuList);

          // 搜索SKU关联的产品列表
          this.getProdutsRelatedToSKU();

          // 渲染流程图
          if (!type) {
            this.zrenderInit();
          }
        })
        .catch(console.log);
    },
    // 搜索SKU详情
    getSkuDetail(skuCode) {
      const params = {
        params: {
          spuId: this.spuId,
        },
      };
      return this.$q.newProduct
        .getProductBySkuCodeList(params)
        .then(({ data }) => {
          data.forEach((item) => {
            this.updateRelatedProducts(item);
          });
        })
        .catch((err) => {
          console.log(err);
          return {};
        });
    },
    // 搜索SKU关联的产品信息
    getProdutsRelatedToSKU() {
      this.getSkuDetail();
      // const getSkuDetailArr = this.skuList.map(item => {
      //   return this.getSkuDetail(item.skuCode)
      //     .catch(err => {
      //       console.log(err);
      //       return {};
      //     });
      // })
      // return Promise.all(getSkuDetailArr)
      //   .then(result => {
      //     result.forEach(item => {
      //       this.updateRelatedProducts(item);
      //     });
      //   });
    },
    // 更新sku关联产品数据
    updateRelatedProducts(skuInfo) {
      const targetSku = this.skuList.find((item) => item.dataId === skuInfo.dataId);
      if (targetSku) {
        targetSku.loading = false;
        targetSku.tableData = skuInfo.productList[0] ? skuInfo.productList : [];
      }
    },
    showPublishProgress(skuId) {
      this.skuId = skuId;
      this.isShowProgress = true;
    },
    async updateSkuList() {
      await this.getProgressInfo();
      await this.getSpuDetail();
    },
    // 按钮操作后回调
    async updateAfterOperation({ skuCode, skuId }) {
      await this.getProgressInfo();
      await this.getSpuDetail(true);
      await this.updateSkuInfo({ skuCode, skuId });
      // this.getFilesCount();
      this.checkHasPlan();
      this.zrenderInit();
    },
    // 批量操作后回调
    async updateAfterBatchOperation() {
      await this.getProgressInfo();
      await this.getSpuDetail();
      this.checkHasPlan();
    },
    // 只更新sku的基本信息
    updateSkuInfo({ skuCode, skuId }) {
      if (!skuCode || !skuId) {
        return;
      }
      const params = {
        params: {
          skuCode,
          spuId: this.spuId,
        },
      };
      return this.$q.newProduct
        .getSkuRelatedProduts(params)
        .then(({ data }) => {
          if (data) {
            const targetSku = this.skuList.find((item) => item.dataId === skuId);
            if (targetSku) {
              assignValue(targetSku, data);
              targetSku.isEnd = data.isEnd;
              targetSku.isPlan = data.isPlan;
              targetSku.isStart = data.isStart;
              targetSku.tableData = data.productList || [];
              console.log(this.skuList, this.currentStep);
            }
          }
        })
        .catch(console.log);
    },
    showPicture(picData) {
      this.picData = (picData || []).map((item) => ({ url: item.path || item.url }));
      this.isShowPicture = true;
    },
    // 更新流程节点描述信息
    updateStepDescription(taskList) {
      let newArrivalCount = 0,
        sampleGroupCount = 0,
        shootingCount = 0,
        retouchingCount = 0,
        paperworkCount = 0,
        filesCount = 0,
        designCount = 0,
        sectioningCount = 0,
        preparationCount = 0,
        finishedCount = 0,
        renderCount = 0;

      taskList.forEach((item) => {
        switch (+item.taskId) {
          case stepEnum.newArrival:
            newArrivalCount = item.num || 0;
            break;
          case stepEnum.sampleGroup:
            sampleGroupCount = item.num || 0;
            break;
          case stepEnum.shooting:
            shootingCount = item.num || 0;
            break;
          case stepEnum.retouching:
            retouchingCount = item.num || 0;
            break;
          case stepEnum.paperwork:
            paperworkCount = item.num || 0;
            break;
          case stepEnum.files:
            filesCount = item.num || 0;
            break;
          case stepEnum.design:
            designCount = item.num || 0;
            break;
          case stepEnum.sectioning:
            sectioningCount = item.num || 0;
            break;
          case stepEnum.preparation:
            preparationCount = item.num || 0;
            break;
          case stepEnum.finished:
            finishedCount = item.num || 0;
            break;
          case stepEnum.render:
            renderCount = item.num || 0;
            break;
          default:
            break;
        }
      });
      this.stepDescription = {
        newArrival: newArrivalCount > 0 ? `${newArrivalCount}个SKU` : '',
        sampleGroup: sampleGroupCount > 0 ? `${sampleGroupCount}个SKU` : '',
        shooting: shootingCount > 0 ? `${shootingCount}个SKU` : '',
        retouching: retouchingCount > 0 ? `${retouchingCount}个SKU` : '',
        files: filesCount > 0 ? `${filesCount}个SKU` : '',
        paperwork: paperworkCount > 0 ? `${paperworkCount}个SKU` : '',
        design: designCount > 0 ? `${designCount}个SKU` : '',
        sectioning: sectioningCount > 0 ? `${sectioningCount}个SKU` : '',
        preparation: preparationCount > 0 ? `${preparationCount}个SKU` : '',
        finished: finishedCount > 0 ? `${finishedCount}个SKU` : '',
        render: renderCount > 0 ? `${renderCount}个SKU` : '',
      };
    },
    // sku刷新
    refreshSku(skuId, skuCode) {
      this.updateSkuInfo({ skuCode, skuId });
    },
    async refresh() {
      this.contentLoading = true;
      await this.$q.newProduct
        .refreshAssociation({
          params: { spuId: this.spuId },
        })
        .catch(console.log);
      await this.getSpuDetail();
      this.contentLoading = false;
    },
    async updateProgressInfo() {
      // 更新流程图状态
      await this.getProgressInfo();
      // 刷新sku节点状态
      await this.getSpuDetail();
      // 更新是否显示提示
      // this.getFilesCount();
      this.zrenderInit();
    },
    // 搜索产品资料数量
    getFilesCount() {
      const params = {
        params: {
          spuId: this.spuId,
          type: 5,
        },
      };
      this.$q.newProduct
        .queryProductDataCopywriting(params)
        .then(({ data }) => {
          this.filesCount = data.length;
        })
        .catch(console.log);
    },
    // 是否制定摄影，页面计划,渲染计划
    checkHasPlan() {
      const params = {
        data: {
          spuId: this.spuId,
        },
      };
      this.$q.newProduct
        .startShootingPlanList(params)
        .then(({ data }) => {
          // 同时存在拍摄计划时间，拍摄人员，修片计划时间，修片人员
          this.hasPhotographyPlan = data.some((item) => {
            return !!item.planShooting && !!item.shootingEnd && !!item.shootPerson && !!item.planRetouching && !!item.retouchingEnd && !!item.retouchingPerson;
          });
          // 同时存在渲染计划时间，渲染人员
          this.renderPlan = data.some((item) => {
            return !!item.planRenderStart && !!item.planRenderEnd && !!item.planRenderPerson;
          });
          // 同时存在渲切片划时间，切片人员
          this.sectionPlan = data.some((item) => {
            return !!item.planSection && !!item.sectionEnd && !!item.sectionPerson;
          });
          console.log('renderPlan', this.renderPlan);
          // 同时存在设计计划时间，设计人员，切片计划时间，切片人员
          this.hasPagePlan = data.some((item) => {
            if (this.spuInfo.productTypeCode == 5) {
              return !!item.planSection && !!item.sectionEnd && !!item.sectionPerson;
            } else {
              return !!item.planSection && !!item.sectionEnd && !!item.sectionPerson;
            }
          });
          // 是否是跳过了设计节点
          // this.isJumpDesign = data.some(item => {
          //   return !item.planDesign && !item.designEnd && !item.designPerson
          //   && this.currentStep > this.stepEnum.design
          // });
          // console.log(this.isJumpDesign);
        })
        .catch(console.log);
    },
    onAddPlan() {
      this.checkHasPlan();
      this.getSpuDetail();
    },
    // 完成上架
    async onPublished() {
      await this.getProgressInfo();
      await this.getSpuDetail();
    },
    checkFilesNew() {
      const params = {
        params: {
          spuId: this.spuId,
        },
      };
      return this.$q.newProduct
        .checkFilesNew(params)
        .then(({ data }) => {
          this.isFilesNew = data.information > 0;
          this.isIntroductionsNew = data.paperwork > 0;
          this.isRemarkNew = data.remark > 0;
          this.shootingConfig = data.shootingConfig == 'Y';
        })
        .catch(console.log);
    },
    handleBatchProcessingComplete({ activeKey, skuId, skuCode, taskId, spuId, tableData }) {
      if (!tableData) {
        this[activeKey](skuId, skuCode, taskId, spuId);
      } else {
        this[activeKey](skuId, skuCode, spuId, tableData);
      }
    },
    //startTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false, currentStep)
    //showCompleteTask(skuInfo.dataId, skuInfo.skuCode, skuInfo.taskId, false, currentStep)
    batchRender({ type, skuId, skuCode, taskId, spuId }) {
      if (!type) {
        this.startTask(skuId, skuCode, taskId, false, this.currentStep);
      } else {
        this.showCompleteTask(skuId, skuCode, taskId, false, this.currentStep);
      }
    },
    isSkipDemandVisible(skuInfo) {
      if (this.spuInfo && (this.spuInfo.productTypeCode == '1' || this.spuInfo.productTypeCode == '3' || this.spuInfo.productTypeCode == '4')) {
        //  首批需求不完整
        if (skuInfo.tableData.find((v) => !v.demand)) {
          return true;
        } else {
          return false;
        }
        //  skuInfo.tableData.find(v=>!v.demand)
        // skuInfo.isSkipDemand == 1
      } else {
        return false;
      }
    },
  },
  filters: {
    stepFormat(val, that) {
      const map = {
        [stepEnum.newArrival]: '开始制作',
        [stepEnum.sampleGroup]: '样品组货',
        [stepEnum.shooting]: '拍摄',
        [stepEnum.retouching]: '修片',
        [stepEnum.paperwork]: '产品文案',
        [stepEnum.design]: '设计',
        [stepEnum.sectioning]: '切片',
        [stepEnum.preparation]: '准备上架',
        [stepEnum.finished]: '完成上架',
        [stepEnum.render]: '渲染',
      };

      if (that) {
        return that.stepMap[val] || '';
      }
      return map[val] || '';
    },
    yesOrNo(val) {
      const map = {
        是: '是',
        否: '否',
      };
      return map[val] || '';
    },
  },
  created() {
    console.log('renderPlan', this.renderPlan);
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.flex-between
  display flex
  align-items center
  justify-content space-between
.flex0
  flex none
.flex1
  flex 1
.flex8
  flex .7
  text-align right
.flex2
  flex .3
.note
  color #999
.weighted
  font-weight bold

.detail-content
  padding 10px
  .spu-panel
    position relative
    background-color #fff
    border-radius 3px
    color #303133
    padding-left 90px
    margin-top 15px
    &-title
      padding 5px 10px
    &-content
      padding 10px
      border-top 1px solid #ebeef5
  .step-panel
    // padding 15px 10px
    margin 10px 0
    background-color #fff
    border-radius 3px
    .step-extra-wrap
      position relative
      width calc(50% - 18px)
      .step-extra
        width calc(50% + 5px)
        position relative
        left 49.5%
        box-sizing border-box
        border-top 2px solid
        border-right 2px solid
        border-top-right-radius 4px
        color #C0C4CC
        border-color #C0C4CC
        .step-header
          position absolute
          top -11px
          left 0
          background #fff
          .step-icon
            box-sizing border-box
            width 20px
            height 20px
            border-radius 50%
            border 2px solid
            &.is-progress
              color #303133
              border-color #303133
        .step-main
          margin-top 10px
          padding-bottom 10px
          &.is-progress
            color #303133
            border-color #303133
            .step-title
              font-weight bold
          .step-title
            line-height 2
          .step-description
            font-size 12px
        &.is-success
          color #0bb78e
          border-color #0bb78e

    >>> .el-step
      .el-step__title
        font-size 14px
        line-height 2
      .el-step__head.is-success,
      .el-step__title.is-success,
      .el-step__description.is-success
        color #0BB78E
      .el-step__head.is-success
        border-color #0BB78E
      .el-step__icon
        width 20px
        height 20px
      .el-step__icon-inner
        display none
  .sku-panel
    margin-bottom 10px
    .sku-card
      padding 10px
      background-color #fff
      border-radius 3px
      &-title,
      &-info,
      .sku-related-table-desc
        padding 6px 0
      &-title
        &-left
          display flex
          .sku-code
            align-items center
            width auto
          .sku-step
            display inline-block
            padding 5px
            color #0BB78E
            background-color rgba(11, 183, 142, 0.1)
      .sku-related-table
        margin-top 5px
        >>> .el-table__header
          th div
            line-height 23px
        .pop-reference
          line-height 23px !important
    .sku-card+.sku-card
      margin-top 10px
  .badge-item
    margin-right 0px
  .check-btn
    padding 2px
    >>> i
      font-weight bold
</style>
<style lang="stylus">
.pop-box
  &-title
    font-size 14px
    color red
  &-content
    font-size 12px
    line-height 1.5
    span
      color red
</style>
<style lang="stylus" scoped>
.spu-img
  position absolute
  left 5px
  top -15px
  border 4px solid #ffffff
  overflow hidden
  cursor pointer
  box-shadow 0 0 8px 3px rgba(0,0,0,0.1)
  .img-num
    position absolute
    right 0
    bottom 0
    width 18px
    height 18px
    background rgba(0,0,0,0.3)
    color #fff
    text-align center
    line-height 18px
    font-size 12px
    z-index 10
  >>> .el-image
    display block
    transition all linear .2s
    &::after
      transition all linear .2s
      position absolute
      left 0
      top 0
      width 100%
      height 100%
      content ""
      background rgba(0,0,0,0.1)
    &:hover
      transform scale(1.05)
      &::after
        background rgba(0,0,0,0.2)

#zrenderEl
  width 100%
  height 130px

.tips
  display inline-block
  padding 5px
  color #E6A23C
.stop-tip
  display inline-block
  padding 5px
  margin-left 5px
  color #fff
  background-color #f23d20
.tip-success
  color #0BB78E

.flex8 >>> .el-button
  margin-left 8px
  margin-bottom 4px
  margin-top 4px
</style>